<template>
  <div>
    <div class="thank-you-container">
      <p style="font-weight: 600; font-size: 35px; color: #00346b; margin: 0px 0px 20px">
        Thank you for registering for the 2023 Teach Coalition Visionary Retreat.
      </p>
      <p style="margin: 0px 0px 20px">
        We are excited to welcome you on November 8th to The Mandarin Oriental Hotel in Miami Florida.
      </p>
      <p style="margin: 0px 0px 20px">
        Please be at the hotel by 7pm for Dinner and the Keynote Speaker.
      </p>
      <p style="margin: 0px 0px 20px">
        We invite you to extend your stay at The Mandarin Oriental Hotel in Miami Florida with an exclusive Teach Coalition group discount code. Please call the hotel directly 305-913-8288 to extend your stay.
      </p>
    </div>
  </div>
</template>
<style scoped>
.thank-you-container {
  padding: 20px;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
}
</style>
